import { GeoCoordinate, TrackableAssetState, TrackableAssetStateChangedMessage } from '@/api/types';
import store from '@/store/index';
import { Action, getModule, Mutation, VuexModule, Module } from 'vuex-module-decorators';
import Vue from 'vue';

@Module({
  namespaced: true,
  name: 'trackingMod',
  dynamic: true,
  store
})
export default class trackingModule extends VuexModule {
  trackableAssetStates: { [trackingDeviceIdentifier: string]: TrackableAssetState } = {};

  get getTrackableAssetHeading() {
    return (trackingDeviceIdentifier: string): number | null => {
      return this.trackableAssetStates[trackingDeviceIdentifier]?.heading;
    };
  }

  get getTrackableDateTimeUtc() {
    return (trackingDeviceIdentifier: string): Date | null => {
      return this.trackableAssetStates[trackingDeviceIdentifier]?.locationDateTimeUtc;
    };
  }

  get getTrackableAssetLocation() {
    return (trackingDeviceIdentifier: string): GeoCoordinate | null => {
      if (!this.trackableAssetStates[trackingDeviceIdentifier]) return null;

      return {
        latitude: this.trackableAssetStates[trackingDeviceIdentifier].latitude,
        longitude: this.trackableAssetStates[trackingDeviceIdentifier].longitude
      };
    };
  }

  @Mutation
  private SET_TRACKABLE_ASSET_STATE(payload: { key: string; trackableAssetState: TrackableAssetState }) {
    Vue.set(this.trackableAssetStates, payload.key, payload.trackableAssetState);
  }

  @Action({ rawError: true })
  setTrackableAssetState(trackableAssetStateChangedMessage: TrackableAssetStateChangedMessage) {
    this.SET_TRACKABLE_ASSET_STATE({
      key: trackableAssetStateChangedMessage.trackingDeviceIdentifier,
      trackableAssetState:
        trackableAssetStateChangedMessage.trackableAssetStates[
          trackableAssetStateChangedMessage.trackableAssetStates.length - 1
        ]
    });
  }
}

export const trackingMod = getModule(trackingModule);
